module.exports = __webpack_public_path__ + "static/media/shh.98184f03.png";